import {
  FORGOT_PASSWORD,
} from './constants';

export function forgotPassword(params) {
  return {
    type: FORGOT_PASSWORD,
    ...params,
  };
}
